module.exports = __webpack_public_path__ + "static/media/Map.cd0f4025.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/Map.svg
// module id = 385
// module chunks = 0